import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { SupportFaq } from '../models/supportFaqs.interface';
import { SupportService } from '../services/support.service';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';


export interface FaqCategory {
  categoryId: number;
  categoryName: string;
}


@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})

export class FaqsComponent extends AbstractBiditComponent implements OnInit {

  constructor(@Inject(LOCALE_ID) private locale: string,
    deviceDetectorService: DeviceDetectorService, private supportService: SupportService, private scroller: ViewportScroller,) {
    super(deviceDetectorService);
  }

  nonFilteredFaqs: SupportFaq[];
  faqs: SupportFaq[];
  faqsCategories: FaqCategory[] = [];
  selected: number;
  faqSearchText: string = '';
  
  ngOnInit(): void {
    this.loadFaqs();
  }

  loadFaqs() {
    this.supportService.getFaqList(this.locale)
      .subscribe({
        next: (data) => {
          this.faqs = data;

          this.faqs.forEach(fq => {
            let faqCategory = {} as FaqCategory;
            faqCategory.categoryId = fq.supportFaq_ID;
            faqCategory.categoryName = fq.supportFaq_CategoryName;
            this.faqsCategories.push(faqCategory);
          });

          this.faqsCategories = this.faqsCategories.sort((a,b) => a.categoryName.localeCompare(b.categoryName));
          this.nonFilteredFaqs = this.faqs;
          
        },
        error: (error: string) => this.onError(error)
      });

   // this.faqSelectedCategory = null;
  }

 

  filterFaqs() {
    this.faqs = this.nonFilteredFaqs.filter(f => this.selected === undefined || (f.supportFaq_ID === this.selected)).map(fh => ( {...fh} ));
    
    this.faqs.forEach(f => {
        let filteredLinks = f.hyperlinks.filter(fh => this.faqSearchText === '' || (this.faqSearchText !== '' && fh.supportFaqHyperlink_Description.toLowerCase().includes(this.faqSearchText.toLowerCase())));
        f.hyperlinks = filteredLinks;
    });  

  }

  resetFilter() {
    this.faqs = this.nonFilteredFaqs;
    this.selected = undefined;
    this.faqSearchText = '';
  }
}
